import { createAsyncThunk } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import apiCall from "../../backend/http"

export const fetchAllTemporaryGuests = createAsyncThunk(
  "guests/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/admin/temporary-guests/")
      return response.data
    } catch (error) {
      console.error("Error fetching guests:", error)
      toast.error(error.response?.data?.message || "Failed to fetch guests")
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const createTemporaryGuest = createAsyncThunk(
  "guests/create",
  async (guestData, { rejectWithValue }) => {
    try {
      if (!guestData.email || !guestData.full_name || !guestData.phone_number) {
        throw new Error("Please fill all required fields")
      }

      const response = await apiCall.post("/api/temporary-guests/", guestData)

      toast.success(
        "Guest account created successfully. Please check your email for verification."
      )

      return response.data
    } catch (error) {
      toast.error(
        "Failed to create Account please Check the Fields and Try Again"
      )

      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        details: error.response?.data || error.message
      })
    }
  }
)

export const verifyGuestEmail = createAsyncThunk(
  "guests/verifyEmail",
  async (token, { rejectWithValue }) => {
    try {
      const response = await apiCall.get(`/api/verify-email/${token}/`)
      toast.success("Email verified successfully")
      return response.data
    } catch (error) {
      console.error("Error verifying email:", error)
      toast.error(error.response?.data?.message || "Failed to verify email")
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const checkGuestStatus = createAsyncThunk(
  "guests/checkStatus",
  async (guest_id, { rejectWithValue }) => {
    try {
      const response = await apiCall.get(
        ` /api/temporary-guests/${guest_id}/status/`
      )
      return response.data
    } catch (error) {
      console.error("Error checking guest status:", error)
      toast.error(
        error.response?.data?.message || "Failed to check guest status"
      )
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const createGuestBooking = createAsyncThunk(
  "guests/createBooking",
  async ({ guest_id, bookingData }, { rejectWithValue }) => {
    try {
      if (
        !guest_id ||
        !bookingData ||
        !bookingData.vehicle_bookings ||
        bookingData.vehicle_bookings.length === 0
      ) {
        throw new Error("Missing required booking information")
      }

      const url = `/api/temporary-guests/${guest_id}/create-booking/`

      console.log("Attempting to post to URL:", url)
      console.log("Booking data being sent:", bookingData)

      if (!bookingData.guest_email) {
        throw new Error("Guest email is required")
      }
      if (!bookingData.guest_full_name) {
        throw new Error("Guest full name is required")
      }
      if (!bookingData.guest_phone_number) {
        throw new Error("Guest phone number is required")
      }

      const response = await apiCall.post(url, bookingData)

      return response.data
    } catch (error) {
      console.error("Error creating booking:", error)

      if (error.response && error.response.data) {
        console.error("Server response:", error.response.data)

        let errorDetails = ""
        const errorData = error.response.data

        if (typeof errorData === "object" && errorData !== null) {
          errorDetails = Object.entries(errorData)
            .map(([field, errors]) => {
              if (Array.isArray(errors)) {
                return `${field}: ${errors.join(", ")}`
              } else {
                return `${field}: ${errors}`
              }
            })
            .join("; ")
        }

        const errorMessage = errorDetails
          ? `Booking failed: ${errorDetails}`
          : error.response?.data?.message || "Failed to create booking"

        toast.error(errorMessage)
        return rejectWithValue(error.response?.data || "Unknown error occurred")
      }

      toast.error("Failed to create booking. Please try again.")
      return rejectWithValue("Unknown error occurred")
    }
  }
)

export const extendGuestExpiration = createAsyncThunk(
  "guests/extendExpiration",
  async (guestId, { rejectWithValue }) => {
    try {
      const response = await apiCall.post(
        `/api/admin/temporary-guests/${guestId}/extend-expiration/`
      )
      toast.success("Expiration extended successfully")
      return response.data
    } catch (error) {
      console.error("Error extending expiration:", error)
      toast.error(
        error.response?.data?.message || "Failed to extend expiration"
      )
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const checkGuestEmail = createAsyncThunk(
  "guests/checkEmail",
  async (email, { rejectWithValue, dispatch }) => {
    try {
      if (!email) {
        throw new Error("Email is required")
      }

      const response = await apiCall.post(
        "/api/temporary-guests/check-email/",
        { email }
      )
      console.log("Check email response:", response.data)

      return {
        exists: response.data.exists,
        is_verified: response.data.is_verified,
        id: response.data.id,
        full_name: response.data.full_name,
        phone_number: response.data.phone_number,
        guest_reference: response.data.guest_reference,
        guest_id: response.data.guest_id,

        guest: response.data.exists
          ? {
              email: email,
              is_verified: response.data.is_verified,
              full_name: response.data.full_name,
              phone_number: response.data.phone_number,
              guest_reference: response.data.guest_reference,
              id: response.data.id,
              guest_id: response.data.guest_id
            }
          : null
      }
    } catch (error) {
      console.error("Error checking email:", error)

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to check email"

      toast.error(errorMessage)

      return rejectWithValue({
        message: errorMessage,
        status: error.response?.status,
        details: error.response?.data || error.message
      })
    }
  }
)

export const fetchAllImageSpecs = createAsyncThunk(
  "fleet/fetchAllImageSpecs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall.get("/api/fleet/image_specs/")
      return response.data
    } catch (error) {
      toast.error(error.response?.data?.message)
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const createImageSpec = createAsyncThunk(
  "fleet/createImageSpec",
  async (imageSpecData, { rejectWithValue }) => {
    try {
      let formData = new FormData()

      if (imageSpecData.image) {
        if (
          typeof imageSpecData.image === "string" &&
          imageSpecData.image.startsWith("data:")
        ) {
          const base64Response = await fetch(imageSpecData.image)
          const imageBlob = await base64Response.blob()

          formData.append("image", imageBlob, "image.jpg")
        } else if (
          imageSpecData.image instanceof File ||
          imageSpecData.image instanceof Blob
        ) {
          formData.append(
            "image",
            imageSpecData.image,
            imageSpecData.image.name || "image.jpg"
          )
        }
      }

      if (imageSpecData.specs && Array.isArray(imageSpecData.specs)) {
        for (let i = 0; i < imageSpecData.specs.length; i++) {
          formData.append(`specs[${i}]`, imageSpecData.specs[i] || "")
        }
      }

      if (imageSpecData.order !== undefined) {
        formData.append("order", imageSpecData.order)
      }

      const response = await apiCall.post("/api/fleet/image_specs/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })

      toast.success("Image spec created successfully")
      return response.data
    } catch (error) {
      console.error("Error creating image spec:", error)

      let errorMessage = "Failed to create image spec"
      if (error.response && error.response.data) {
        if (typeof error.response.data === "object") {
          errorMessage = Object.entries(error.response.data)
            .map(([field, errors]) => {
              if (Array.isArray(errors)) {
                return `${field}: ${errors.join(", ")}`
              } else {
                return `${field}: ${errors}`
              }
            })
            .join("; ")
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message
        }
      }

      toast.error(errorMessage)
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const retrieveImageSpec = createAsyncThunk(
  "fleet/retrieveImageSpec",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCall.get(`/api/fleet/image_specs/${id}/`)
      return response.data
    } catch (error) {
      console.error("Error retrieving image spec:", error)
      toast.error(
        error.response?.data?.message || "Failed to retrieve image spec"
      )
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const updateImageSpec = createAsyncThunk(
  "fleet/updateImageSpec",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      let formData = new FormData()

      // Handle image data - convert from base64 if needed
      if (data.image) {
        if (typeof data.image === "string" && data.image.startsWith("data:")) {
          // Extract the base64 data and convert to a Blob
          const base64Response = await fetch(data.image)
          const imageBlob = await base64Response.blob()

          // Add the Blob to FormData as a file
          formData.append("image", imageBlob, "image.jpg")
        } else if (data.image instanceof File || data.image instanceof Blob) {
          // If it's already a File or Blob object, use it directly
          formData.append("image", data.image, data.image.name || "image.jpg")
        }
      }

      // Add other fields to the FormData
      if (data.specs && Array.isArray(data.specs)) {
        // Backend expects specs as individual items, not as a JSON string
        for (let i = 0; i < data.specs.length; i++) {
          formData.append(`specs[${i}]`, data.specs[i] || "")
        }
      }

      if (data.order !== undefined) {
        formData.append("order", data.order)
      }

      const response = await apiCall.put(
        `/api/fleet/image_specs/${id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      )

      toast.success("Image spec updated successfully")
      return response.data
    } catch (error) {
      console.error("Error updating image spec:", error)
      toast.error(
        error.response?.data?.message || "Failed to update image spec"
      )
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const partialUpdateImageSpec = createAsyncThunk(
  "fleet/partialUpdateImageSpec",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      let formData = new FormData()

      if (data.image) {
        if (typeof data.image === "string" && data.image.startsWith("data:")) {
          const base64Response = await fetch(data.image)
          const imageBlob = await base64Response.blob()
          formData.append("image", imageBlob, "image.jpg")
        } else if (data.image instanceof File || data.image instanceof Blob) {
          formData.append("image", data.image, data.image.name || "image.jpg")
        }
      }

      if (data.specs && Array.isArray(data.specs)) {
        for (let i = 0; i < data.specs.length; i++) {
          formData.append(`specs[${i}]`, data.specs[i] || "")
        }
      }

      if (data.order !== undefined) {
        formData.append("order", data.order)
      }

      const response = await apiCall.patch(
        `/api/fleet/image_specs/${id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      )

      toast.success("Image spec updated successfully")
      return response.data
    } catch (error) {
      console.error("Error updating image spec:", error)
      toast.error(
        error.response?.data?.message || "Failed to update image spec"
      )
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)

export const deleteImageSpec = createAsyncThunk(
  "fleet/deleteImageSpec",
  async (id, { rejectWithValue }) => {
    try {
      await apiCall.delete(`/api/fleet/image_specs/${id}/`)
      toast.success("Image spec deleted successfully")
      return id
    } catch (error) {
      console.error("Error deleting image spec:", error)
      toast.error(
        error.response?.data?.message || "Failed to delete image spec"
      )
      return rejectWithValue(error.response?.data || "Unknown error occurred")
    }
  }
)
